export const environment = {
    production: false,
    clientId : 'abeab0ce-4e8b-42f7-955b-fe7cd1bbfb99',
    scope : 'Read',
    scopeUri : 'https://swapapilotsdev.onmicrosoft.com/ContractAI',
    replyUrl : 'https://contractai-dev.swapa.org',
    apiOrigin : 'https://contractai-api-dev.swapa.org',

    // Azure AD B2C policies
    signInPolicy: 'B2C_1A_SEAMLESSMIGRATION_SIGNIN',
    passwordResetPolicy: 'B2C_1A_ForgotPasswordSeamless',

    authorityURI : 'https://logindev.swapa.org/swapapilotsdev.onmicrosoft.com/B2C_1A_SEAMLESSMIGRATION_SIGNIN',
    knownAuthority : 'logindev.swapa.org',
    appInsightsConnectionString: 'InstrumentationKey=1ca16fa4-a265-4f32-bdec-31d07c31d337;IngestionEndpoint=https://southcentralus-0.in.applicationinsights.azure.com/;LiveEndpoint=https://southcentralus.livediagnostics.monitor.azure.com/;ApplicationId=93599ffd-1011-4b3a-bd58-8fcac9c1ca8b'
};
